// # Modern Auth Header component with animations and scroll behavior
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './authHeader.css';  // # Import the CSS for styling

function AuthHeader() {
  // # Track scroll position for header animation
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // # Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // # Determine active page
  const isSignIn = location.pathname === '/signin';
  const isSignUp = location.pathname === '/signup';

  return (
    <header className={`ath_hdr_auth-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="ath_hdr_auth-header-content">
        <div className="ath_hdr_auth-logo-section">
          <Link to="/" className="ath_hdr_auth-logo">
            <img src="/icons/TEMPU_Logo.png" alt="TEMP-U Logo" />
          </Link>
          <div className="ath_hdr_auth-title-container">
            <h1 className="ath_hdr_auth-title">TEMP-U</h1>
            <div className="ath_hdr_auth-title-full">
              The Egyptian Mentorship Program for USMLE
            </div>
          </div>
        </div>
        
        <nav className="ath_hdr_auth-nav">
          <Link 
            to="/signin" 
            className={`ath_hdr_auth-nav-link ${isSignIn ? 'active' : ''}`}
          >
            Sign In
          </Link>
          <Link 
            to="/signup" 
            className={`ath_hdr_auth-nav-link ${isSignUp ? 'active' : ''}`}
          >
            Sign Up
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default AuthHeader; 